import React from 'react'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'

const styles = () => ({
  root: {
    padding: 16
  }
})

const GridContainer = ({
  children,
  classes,
  className,
  root,
  spacing,
  ...props
}) => (
  <Grid
    container
    spacing={spacing || 1}
    className={classNames(className, root && classes.root)}
    {...props}
  >
    {children}
  </Grid>
)

export default withStyles(styles)(GridContainer)
